(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7268],{

/***/ 70946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LiveStreamCommentBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10184);
/* harmony import */ var components_common_ProgressRing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8325);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8405);
/* harmony import */ var components_common_Button__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98133);
/* harmony import */ var _CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(66229);
/* harmony import */ var _CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var components_common_TextEditor__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55646);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(21694);
/* harmony import */ var common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67027);
/* harmony import */ var service_post__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(87350);
/* harmony import */ var common_utils_debounce__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(80582);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(88767);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(22467);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(38367);
/* harmony import */ var common_utils_post__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(40783);



















function LiveStreamCommentBox(param) {
    var sendMessage = param.sendMessage, isAbleToComment = param.isAbleToComment, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, creator = param.creator, postType = param.postType;
    var charLimit = 300;
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), postable = ref[0], setPostable = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isBlocking = ref1[0], setIsBlocking = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""), plainText = ref2[0], setPlainText = ref2[1];
    var textLength = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return plainText.length;
    }, [
        plainText
    ]);
    var textEditorRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    var showPaymentDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.showPaymentDialog;
    });
    var setShowMembershipPayDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var setSnackbarMessage = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), textPolicies = ref3[0], setTextPolicies = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), blackUrls = ref4[0], setBlackUrls = ref4[1];
    var usingTextPolices = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return textPolicies.filter(function(po) {
            return po.level === service_post__WEBPACK_IMPORTED_MODULE_11__/* .PolicyLevel.SuperHigh */ .VV.SuperHigh;
        });
    }, [
        textPolicies
    ]);
    var hasPolicyError = usingTextPolices.length > 0 || blackUrls.length > 0;
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setPostable(textLength > 0 && textLength <= charLimit && plainText.trim().length > 0);
    }, [
        textLength,
        charLimit,
        plainText
    ]);
    var ref5 = (0,react_query__WEBPACK_IMPORTED_MODULE_12__.useMutation)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(plainText) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        return _ctx.abrupt("return", (0,service_post__WEBPACK_IMPORTED_MODULE_11__/* .checkPolicyCommentText */ .mf)(plainText));
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(plainText) {
            return _ref.apply(this, arguments);
        };
    }(), {
        onSuccess: function(data) {
            var ref, ref1;
            // only update when have different data
            var policies = (data === null || data === void 0 ? void 0 : (ref = data.data) === null || ref === void 0 ? void 0 : ref.words) || [];
            var isSame = policies.length === textPolicies.length && policies.every(function(pl) {
                return textPolicies.some(function(policy) {
                    return policy.name === pl.name;
                });
            });
            if (!isSame) setTextPolicies(policies);
            var urls = (data === null || data === void 0 ? void 0 : (ref1 = data.data) === null || ref1 === void 0 ? void 0 : ref1.urls) || [];
            var isSameUrls = urls.length === blackUrls.length && urls.every(function(blUrl) {
                return blackUrls.some(function(url) {
                    return url.url === blUrl.url;
                });
            });
            if (!isSameUrls) setBlackUrls(urls);
        }
    }), checkPostText = ref5.mutate, isCheckingText = ref5.isLoading;
    var debouncedCheckPostText = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,common_utils_debounce__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(checkPostText, 1000);
    }, [
        checkPostText
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!textEditorRef.current) return;
        textEditorRef.current.forceRender();
    }, [
        textPolicies,
        blackUrls
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        debouncedCheckPostText(plainText);
    }, [
        plainText,
        debouncedCheckPostText
    ]);
    var handleMakeComment = function() {
        if (!postable || !isAbleToComment || isCheckingText) return;
        if (hasPolicyError) return;
        if (isBlocking) return;
        if (!currentUser) {
            showLogin({});
        } else {
            var ref;
            if (isLocked) {
                if (postType === common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__/* .PostType.Gold */ .hQ.Gold) {
                    setShowMembershipPayDialog({
                        open: true,
                        showMembershipStatus: false,
                        initPackage: common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__/* .MembershipPackageName.Platinum */ .uh.Platinum,
                        screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_10__/* .ScreenName.PostDetail */ .CG.PostDetail
                    });
                    setSnackbarMessage({
                        type: "warning",
                        text: "GOLDメンバーシップに登録してLIVEに参加しましょう",
                        autoHideDuration: 10000
                    });
                } else {
                    if (creator.is_open_for_subscription) {
                        showPaymentDialog({
                            creator: creator
                        });
                        var message = postType === common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__/* .PostType.Plus */ .hQ.Plus ? "プライムPlusを登録してLIVEに参加しましょう" : postType === common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__/* .PostType.Paid */ .hQ.Paid ? "プライム登録してLIVEに参加しましょう" : "";
                        if (message) {
                            setSnackbarMessage({
                                type: "warning",
                                text: message,
                                autoHideDuration: 10000
                            });
                        }
                    } else {
                        setSnackbarMessage({
                            type: "error",
                            text: (0,common_utils_post__WEBPACK_IMPORTED_MODULE_14__/* .exCreatorPostLockMessage */ .e8)(postType)
                        });
                    }
                }
                return;
            }
            var messsageContent = "";
            try {
                var ref1;
                messsageContent = (ref1 = textEditorRef.current) === null || ref1 === void 0 ? void 0 : ref1.getContent();
            } catch (error) {
                messsageContent = "";
            }
            messsageContent = messsageContent.replace(/\n/g, " ").trim();
            if (messsageContent.length === 0) return;
            sendMessage(messsageContent);
            (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_17__/* .track */ .j)("Send Live Chat", {
                post_type: postType,
                media_type: common_interfaces_api__WEBPACK_IMPORTED_MODULE_9__/* .MediaType.Stream */ .DD.Stream
            });
            (ref = textEditorRef.current) === null || ref === void 0 ? void 0 : ref.reset();
            setIsBlocking(true);
            setTimeout(function() {
                setIsBlocking(false);
            }, 1000);
        }
    };
    var avatarEl = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().avatar),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_RoundIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            user: currentUser,
            width: 35,
            height: 35,
            hasRing: true,
            emotion: currentUser === null || currentUser === void 0 ? void 0 : currentUser.emotion
        })
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().commentBox),
            children: [
                hasPolicyError && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().alert),
                    children: [
                        "投稿ポリシーに違反している可能性があります。詳しくは",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                            target: "_blank",
                            href: common_utils__WEBPACK_IMPORTED_MODULE_13__/* .POST_POLICY_URL */ .BV,
                            children: "投稿ポリシー"
                        }),
                        "をご覧ください。"
                    ]
                }),
                avatarEl,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().inputBox),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().textInputWrapper),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().textInput),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_TextEditor__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                    ref: textEditorRef,
                                    setPlainText: setPlainText,
                                    onEnter: handleMakeComment,
                                    placeholder: "コメントする",
                                    initialText: "",
                                    charLimit: charLimit,
                                    blackUrls: blackUrls,
                                    textPolicies: usingTextPolices
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().rightSide),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                    className: (_CommentBox_module_scss__WEBPACK_IMPORTED_MODULE_18___default().progress),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_ProgressRing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        radius: 18,
                                        current: textLength,
                                        total: charLimit
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    disabled: !postable || !isAbleToComment || isBlocking || hasPolicyError || isCheckingText,
                                    onClick: handleMakeComment,
                                    text: "送信",
                                    rounded: true,
                                    verticalPadding: 6
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 95160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TippedListDialog; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(14924);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(93579);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22467);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88767);
/* harmony import */ var components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68330);
/* harmony import */ var _TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(81234);
/* harmony import */ var _TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var service_payment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43827);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8405);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(37975);
/* harmony import */ var components_common_TippedItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7923);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(12800);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var components_common_LinkButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22396);
/* harmony import */ var _UserInfo__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(92371);



















function TippedListDialog(param) {
    var open = param.open, setOpen = param.setOpen, postId = param.postId, _isLiveCreator = param.isLiveCreator, isLiveCreator = _isLiveCreator === void 0 ? false : _isLiveCreator, handleChooseUser = param.handleChooseUser;
    var isMobile = (0,common_utils__WEBPACK_IMPORTED_MODULE_2__/* .useMediaQuery */ .ac)("(max-width: 767px)");
    var shouldRefetchTippedListOfPost = (0,store_timeline__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP)(function(state) {
        return state.shouldRefetchTippedListOfPost;
    });
    var isAuthInit = (0,store_global__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(state) {
        return state.isAuthInit;
    });
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_3__.useInfiniteQuery)([
        "getTippedListDialogOfPost",
        postId === null || postId === void 0 ? void 0 : postId.toString()
    ], function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
            var _pageParam, pageParam;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!(!open || !postId || !isAuthInit)) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", Promise.reject());
                    case 3:
                        _ctx.next = 5;
                        return (0,service_payment__WEBPACK_IMPORTED_MODULE_5__/* .getTippedOfPost */ .p3)(postId, pageParam);
                    case 5:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), {
        getNextPageParam: function(lastPage, pages) {
            var ref;
            var list = lastPage === null || lastPage === void 0 ? void 0 : (ref = lastPage.data) === null || ref === void 0 ? void 0 : ref.tipped_users;
            if (list && list.length > 0) {
                return pages.length + 1;
            }
        },
        enabled: isAuthInit && open,
        refetchOnWindowFocus: false
    }), refetch = ref.refetch, data = ref.data, fetchNextPage = ref.fetchNextPage, isFetchingNextPage = ref.isFetchingNextPage;
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        if (shouldRefetchTippedListOfPost) {
            void refetch();
        }
    }, [
        shouldRefetchTippedListOfPost,
        refetch
    ]);
    var pages = data === null || data === void 0 ? void 0 : data.pages;
    var tippedInfos = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return pages ? pages.reduce(function(curr, page) {
            var ref;
            var infos = ((ref = page.data) === null || ref === void 0 ? void 0 : ref.tipped_users) || [];
            return curr.concat(infos);
        }, []) : [];
    }, [
        pages
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Dialog__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
        open: open,
        onClose: function() {
            return setOpen(false);
        },
        maxWidth: "lg",
        fullScreen: isMobile,
        scroll: "body",
        PaperProps: {
            style: {
                backgroundColor: "transparent",
                boxShadow: "none",
                padding: isMobile ? "5vh 0 5vh 0" : ""
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().dialogWrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().header),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().title),
                            children: "購入されたありがとう"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().closeBtn),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                                name: "close-black",
                                width: 16,
                                height: 16,
                                onClick: function() {
                                    return setOpen(false);
                                }
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_InfiniteScroll__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    fetchNextPage: fetchNextPage,
                    isLoading: isFetchingNextPage,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_11___default()((_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().container), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)({}, (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().isLiveCreator), isLiveCreator)),
                        children: tippedInfos.map(function(info, index) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tippedItem),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_UserInfo__WEBPACK_IMPORTED_MODULE_13__/* .UserWithDeletedCheck */ .K, {
                                        user: info.user
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tippedInfo),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_TippedItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                tippedInfo: info,
                                                className: (_TippedListDialog_module_scss__WEBPACK_IMPORTED_MODULE_16___default().tippedLabel)
                                            }),
                                            isLiveCreator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_LinkButton__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                                    text: "コメントを見る",
                                                    onClick: function() {
                                                        handleChooseUser && handleChooseUser(info.user);
                                                        setOpen(false);
                                                    }
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, "post-".concat(postId, "-info-").concat(index));
                        })
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 24940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ getMessagesByGroup; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87066);



var getMessagesByGroup = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(groupId, page) {
        var ref;
        return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return axios__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("/chats/groups/".concat(groupId, "/messages?page=").concat(page));
                case 3:
                    _ctx.t1 = ref = _ctx.sent;
                    _ctx.t0 = _ctx.t1 === null;
                    if (_ctx.t0) {
                        _ctx.next = 7;
                        break;
                    }
                    _ctx.t0 = ref === void 0;
                case 7:
                    if (!_ctx.t0) {
                        _ctx.next = 11;
                        break;
                    }
                    _ctx.t2 = void 0;
                    _ctx.next = 12;
                    break;
                case 11:
                    _ctx.t2 = ref.data;
                case 12:
                    return _ctx.abrupt("return", _ctx.t2);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getMessagesByGroup(groupId, page) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 66229:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"commentBox":"CommentBox_commentBox__znnlh","locked":"CommentBox_locked__0Klm9","inputBox":"CommentBox_inputBox__3QxeB","textInputWrapper":"CommentBox_textInputWrapper__MtlTo","textInput":"CommentBox_textInput__Pss_V","avatar":"CommentBox_avatar__c0PV0","rightSide":"CommentBox_rightSide__ASamQ","progress":"CommentBox_progress__52HR_","alert":"CommentBox_alert__MWBf_","footer":"CommentBox_footer__xPVcZ","text":"CommentBox_text__G8l1_"};

/***/ }),

/***/ 81234:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"dialogWrapper":"TippedListDialog_dialogWrapper__lgUra","header":"TippedListDialog_header__qwVB4","title":"TippedListDialog_title__Co7to","closeBtn":"TippedListDialog_closeBtn__2L2Qa","container":"TippedListDialog_container__fER7H","isLiveCreator":"TippedListDialog_isLiveCreator__lc4IR","tippedItem":"TippedListDialog_tippedItem__VsKaO","tippedInfo":"TippedListDialog_tippedInfo__wOt3E","tippedIcon":"TippedListDialog_tippedIcon__hph8i"};

/***/ })

}]);